// Local pre-engine pages still scanned automatically (Login,
// Deploy). The inspire engine's <AppPage> is registered explicitly
// so every controller can render it as the universal entry point
// for engine-backed routes (Rule 6 of /home/vince/inspire/INSPIRE_APP_RULES.md).
import AppPage from "@bloglovin/inspire-engine/Pages/AppPage";

const files = require.context("./pages", true, /\.vue$/);
const modules = [AppPage];
files.keys().forEach(key => {
  if (files(key).default === undefined) {
    throw Error(`Cannot find component in file ${key}`);
  }
  modules.push(files(key).default);
});
export default modules;
